import { Component } from '@angular/core';

@Component({
  selector: 'app-irn-remarks',
  templateUrl: './irn-remarks.component.html',
  styleUrls: ['./irn-remarks.component.css']
})
export class IrnRemarksComponent {

}
